import { useEffect } from 'react';
import { X } from 'lucide-react';

interface CalWidgetProps {
  isOpen: boolean;
  onClose: () => void;
  calLink?: string;
  className?: string;
}

export default function CalWidget({ 
  isOpen, 
  onClose, 
  calLink = 'one80/30min',
  className = '' 
}: CalWidgetProps) {
  useEffect(() => {
    // Prevent body scroll when modal is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 ${className}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl h-[80vh] relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close calendar"
        >
          <X className="h-6 w-6" />
        </button>

        <iframe
          src={`https://cal.com/${calLink}?embed=true`}
          style={{width:"100%", height:"100%", overflow:"scroll", borderRadius: "8px"}}
          frameBorder="0"
          title="Cal.com Scheduling"
          className="w-full h-full rounded-lg"
        ></iframe>
      </div>
    </div>
  );
}